import { Directive, Inject, HostListener, ElementRef } from "@angular/core";
import { NgControl } from "@angular/forms";
import { FormatterServiceToken, FormatterService } from "../formatter/formatter.module";

@Directive({
    selector: "[datePickerInput]",
})
export class DatePickerInputDirective {

    protected _elementRef: ElementRef;

    protected _ngControl: NgControl;

    protected _formatterService: FormatterService;

    protected _focused: boolean;

    constructor(elementRef: ElementRef, ngControl: NgControl,
                @Inject(FormatterServiceToken)
                    formatterService: FormatterService) {
        this._elementRef = elementRef;
        this._ngControl = ngControl;
        this._formatterService = formatterService;
    }

    @HostListener("input", ["$event"])
    onInput(event: Event) {
        const currentValue: string = (<HTMLInputElement>event.currentTarget).value;
        this._elementRef.nativeElement.value
            = currentValue ? currentValue.replace(/[^0-9.]/g, "") : "";
        const dateString: string = currentValue.replace(/\D/g, "");
        if (dateString && dateString.length > 8) {
            this._elementRef.nativeElement.value = currentValue.substring(0, 11);
        }
        if (!this._focused) {
            this.onBlur();
        }
    }

    @HostListener("focus", ["$event"])
    onFocus(event: Event) {
        this._focused = true;
        const currentValue: string = (<HTMLInputElement>event.currentTarget).value;
        /* if (currentValue) {
            currentValue = currentValue.replace(/\D/g, "");
        } */
        this._elementRef.nativeElement.value = currentValue;
        const currentElement: HTMLInputElement = <HTMLInputElement>event.currentTarget;
        if (currentElement && currentElement.value) {
            currentElement.selectionStart = currentElement.selectionEnd = currentValue.length;
        }
    }

    @HostListener("blur", ["$event"])
    onBlur() {
        this._focused = false;
        let dateString: string = this._elementRef.nativeElement.value;
        dateString = dateString.replace(/\D/g, "");
        if (dateString && dateString.length > 7) {
            try {
                const formattedDate: string = dateString.substring(0, 4) + "-" + dateString.substring(4, 6) + "-" + dateString.substring(6, 8);
                const dateValue: string = this._formatterService.formatDate(new Date(formattedDate), "yyyy-MM-dd");
                if (dateValue) {
                    this._ngControl.control.setErrors(null);
                    this.updateValues(dateValue);
                }
            } catch (e) {
                this._ngControl.control.setErrors({invalidValue: true});
            }
        } else {
            this.updateValues("");
        }
    }

    protected updateValues(value: string) {
        this.updateUI(value);
        this.updateModel(value);
    }

    protected updateModel(value: string) {
        this._ngControl.control.setValue(value);
    }

    protected updateUI(value: string) {
        this._ngControl.valueAccessor.writeValue(value);
    }
}
